import { useState, useEffect } from "react"
import CoordinateModule from "../Modules/CoordinateModule"

import * as KingmakerProps from "./DynoComponents/Kingmaker"
import * as EchoChambersProps from "./DynoComponents/EchoChambers"
import * as Influencer from "./DynoComponents/Influencer"
import * as Pulse from './DynoComponents/Pulse'
import * as RNG from './DynoComponents/RNG'
import * as Consensus from './DynoComponents/Consensus'

const COMPONENT_MAP = {
    'kingmaker-rng-king': KingmakerProps.RngKing,
    'kingmaker-boss-slayer': KingmakerProps.BossSlayer,
    'kingmaker-trivia-king': KingmakerProps.TriviaKing,
    'kingmaker-auction-house': KingmakerProps.AuctionHouse,
    'kingmaker-king-of-the-hill': KingmakerProps.KingOfTheHill,
    'kingmaker-tournament': KingmakerProps.Tournament,
    'kingmaker-quickdraw': KingmakerProps.Quickdraw,
    'kingmaker-foreseeing-king': KingmakerProps.ForeseeingKing,
    'echo-chambers-word-cloud': EchoChambersProps.WordCloud,
    'echo-chambers-canvas-wall': EchoChambersProps.CanvasWall,
    'echo-chambers-graffiti-wall': EchoChambersProps.GraffitiWall,
    'echo-chambers-character-sheet' : EchoChambersProps.CharacterSheet,
    'echo-chambers-the-constellation' : EchoChambersProps.TheConstellation,
    'influencer-tug-of-war': Influencer.TugOfWar,
    'influencer-the-selector': Influencer.TheSelector,
    'pulse-emote-podium': Pulse.EmotePodium,
    'pulse-hype-o-meter': Pulse.HypeOMeter,
    'pulse-ab-testing': Pulse.ABTesting,
    'pulse-hivemind': Pulse.Hivemind,
    'rng-minimal': RNG.Minimal,
    'rng-slot-machine': RNG.SlotMachine,
    'rng-wheel-of-fortune': RNG.WheelOfFortune,
    'consensus-voting-board': Consensus.VotingBoard,
    'consensus-survivor': Consensus.Survivor,
    'consensus-jukebox': Consensus.Jukebox,
    'consensus-knockout': Consensus.Knockout
}

export function DynoPicker( props )
{
    const dynoMode = props.dynoMode 
    const dynoTag = props.dynoTag
    const dynoCfg = props.dynoCfg
    const setDynoCfg = props.setDynoCfg

    const selected = props.selected 
    const reset = props.reset 
    const modalOpen = props.modalOpen 

    const Component = COMPONENT_MAP[dynoTag]

    if (!Component) return <></>;

    return <Component dynoCfg={dynoCfg}
                      setDynoCfg={setDynoCfg}
                      selected={selected}
                      reset={reset}
                      modalOpen={modalOpen} />
}

export default function DynoProperties( props )
{
    const layers = props.layers 
    const setLayers = props.setLayers 
    const layersCfg = props.layersCfg
    const selected = props.selected 
    const selectedIdx = props.selectedIdx
    const modalOpen = props.modalOpen
    const accountType = props.accountType
    const reset = props.reset

    const selectedCoords = props.selectedCoords
    const setSelectedCoords = props.setSelectedCoords
    const setManualSelectedCoords = props.setManualSelectedCoords

    const [ name, setName ] = useState(null)
    const [ dynoMode, setDynoMode ] = useState(null)
    const [ dynoTag, setDynoTag ] = useState("")
    const [ dynoCfg, setDynoCfg ] = useState(null)

    const reload = () => {
        if( selectedIdx < 0 )
        {
            return;
        }

        if( !layersCfg.current[selected] )
        {
            return
        }

        setDynoCfg( layersCfg.current[selected] )
        let n = layersCfg.current[selected].name 
        setName( (n) ? n : "" )

        let properties = layersCfg.current[selected].properties

        if( properties == null )
        {
            properties = {}
        }

        setDynoMode( properties.dyno_mode || 'random_picker')
        setDynoTag( properties.dyno_tag )
    }

    useEffect( () => {
        reload()
    },[selected])

    /*useEffect( () => {
        if( dynoMode == null )
        {
            return
        }

        let cfg = structuredClone(dynoCfg)
        cfg.properties.dyno_mode = dynoMode 

        setDynoCfg(cfg)

    },[ dynoMode ])*/

    useEffect( () => {  
        if( dynoCfg == null || dynoMode == null || name == null )
        {
            return
        }

        layersCfg.current[selected].properties = dynoCfg.properties 
        
        if( dynoMode == "image_picker" && dynoCfg.properties.image_picker_cfg )
        {
            if( dynoCfg.properties.image_picker_cfg.images )
            {
                if( dynoCfg.properties.image_picker_cfg.images.length > 0 )
                {
                    const image = dynoCfg.properties.image_picker_cfg.images[0]

                    let w = layersCfg.current[selected].location.width
                    layersCfg.current[selected].location.height = w / image.aspect_ratio
                }
            }
        }

        layersCfg.current[selected].name = name

        setLayers([...layers])

    },[ dynoCfg, name ])

    if( dynoMode == null || dynoCfg == null || name == null )
    {
        return (<></>)
    }

    return (
        <>
            <CoordinateModule coordinates={selectedCoords}
                setCoordinates={setSelectedCoords}
                selected={selected}
                setManual={setManualSelectedCoords}
            />

            {/*<SettingsGroup name="General">
                <Control name="Name">
                    <Form.Control value={name}
                                  onChange={ e => setName(e.target.value) }
                                  size="sm"
                    />
                </Control>
                <div style={{ marginBottom:'10px'}}>
                    <Control name="Dyno mode">
                        <Form.Select style={{ width:'100%'}} size="sm" 
                             value={dynoMode} 
                             onChange={ e => setDynoMode( e.target.value )}
                        >
                            <option value="random_picker">Random Picker</option>
                            <option value="audience_picker">Audience Picker</option>
                            <option value="lottary">Lottary</option>
                            <option value="image_picker">Image Picker</option>
                            <option value="predict">Predict</option>
                            <option value="predict_chat">Predict Chat</option>
                            <option value="word_cloud">Word cloud</option>
                            <option value="poll_large_list">Poll - Large list</option>
                            <option value="tug_a_war">Tug-a-war</option>

                        </Form.Select>
                    </Control>
                </div>
            </SettingsGroup>*/}
            <DynoPicker dynoMode={dynoMode}
                        dynoTag={dynoTag}
                        dynoCfg={dynoCfg}
                        setDynoCfg={setDynoCfg}
                        selected={selected}
                        reset={reset}
                        modalOpen={modalOpen}
            />
        </>
    )
}
